import { Button, Form, Input, Tabs, Upload, message } from 'antd';
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux';
import { Container, Wrapper } from './style';
import {getProfileDetails,updateProfile,updateAddress,updatePassword,updateBrandImage} from '../../actions/profile';
import { InboxOutlined , LoadingOutlined, PlusOutlined} from '@ant-design/icons';
import axios from 'axios';
const { TabPane } = Tabs;
const { Dragger } = Upload;
const Setting = ({getProfileDetails,updateProfile,updateAddress,updatePassword,updateBrandImage}) => {
    const [date, setDate] = useState([])
    const [loading, setLoading] = useState(false)
    const [imageUrl, setImageUrl] = useState(null)
    const [form] = Form.useForm();
    useEffect( async () => {
        const res =  await getProfileDetails()
        setDate(res.data)
        
        form.setFieldsValue({
            mobile_number : res?.data?.mobile_number,
            email : res?.data?.email,
            street_address : res?.data?.address?.street_address,
            post_code :  res?.data?.address?.post_code,
            city : res?.data?.address?.city
        })
    }, [])
    const onProfileFinish = async (values) => {
        const res = await updateProfile(values)
        if(res === 201 ){
            reFresh()
        }
    };
    const onAddressFinish = async (values) => {
        const res = await updateAddress(values)
        if(res === 201 ){
            reFresh()
        }
    };
    const onUploadFinish = async (values) => {
        const res = await updateBrandImage(values)
        if(res === 201 ){
            reFresh()
        }
    };
    const onPasswordFinish = async (values) => {
        const res = await updatePassword(values)
        if(res === 201 ){
            reFresh()
        }
    };

    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };
    const reFresh = async () => {
        const res =  await getProfileDetails()
        setDate(res.data)
    }
    function getBase64(img, callback) {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result));
        reader.readAsDataURL(img);
    }
    function beforeUpload(file) {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
        if (!isJpgOrPng) {
            message.error('You can only upload JPG/PNG file!');
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            message.error('Image must smaller than 2MB!');
        }
        return isJpgOrPng && isLt2M;
    }
    const props = {
        name: 'file',
        previw: false,
        multipleButton: false,
        action: `${process.env.REACT_APP_API_BASE_URL}/client/file/upload`,
        headers: {
            authorization: `Bearer ${localStorage.getItem('token')}`,
          },
          
    onRemove: (file) => {
        const res = axios (`${process.env.REACT_APP_API_BASE_URL}/client/file/delete`,
        {
            headers: {
                'content-type': 'application/json',
                'authorization': `Bearer ${localStorage.getItem("token")}`
            },
            data: {
              file: file?.response?.name,
            },
            method: 'delete'
        
        })
    },
        onChange(info) {
          const { status } = info.file;
          if (status !== 'uploading') {
          }
          if (status === 'done') {
            message.success(`${info.file.name} file uploaded successfully.`);
          } else if (status === 'error') {
            message.error(`${info.file.name} file upload failed.`);
          }
        },
        onDrop(e) {
          console.log('Dropped files', e.dataTransfer.files);
        },
      };
      const uploadButton = (
        <div>
          {loading ? <LoadingOutlined /> : <PlusOutlined />}
          <div style={{ marginTop: 8 }}>Upload</div>
        </div>
      );
      const  handleChange = info => {
        if (info.file.status === 'uploading') {
            setLoading(true);
          return;
        }
        if (info.file.status === 'done') {
          // Get this url from response in real world.
          getBase64(info.file.originFileObj, imageUrl =>
            setImageUrl(imageUrl),
            setLoading(false),
            // this.setState({
            //   imageUrl,
            //   loading: false,
            // }),
          );
        }
      };
      const onRemove = async (file) => {
        const res = await axios (`${process.env.REACT_APP_API_BASE_URL}/client/file/delete`,
        {
            headers: {
                'content-type': 'application/json',
                'authorization': `Bearer ${localStorage.getItem("token")}`
            },
            data: {
              file: file?.response?.name,
            },
            method: 'delete'
        
        })
        if(res?.status === 201){
            setImageUrl(null)
        }
    }
    return (   
    <Wrapper>
         <Container>
          
                <Tabs tabPosition='left' size="small" >
                    <TabPane tab="Update Profile" key="1" >
                        <h1 style={{textAlign: 'center'}}>Update Profile</h1>
                        <Form
                        name="basic"
                        labelCol={{
                            span: 24,
                        }}
                        wrapperCol={{
                            span: 24,
                        }}
                        initialValues={{
                            remember: true,
                        }}
                        onFinish={onProfileFinish}
                        onFinishFailed={onFinishFailed}
                        autoComplete="off"
                        // style={{width: '70%', margin: 'auto'}}
                        form={form}
                        >
                        <Form.Item
                            label="Mobile Number"
                            name="mobile_number"
                            rules={[
                            {
                                required: true,
                                message: 'This field is required!',
                            },
                            {
                                pattern: new RegExp(/^(01)[0-9][0-9]{8}$/),
                                message: 'Please enter a valid mobile number'
                            }
                            ]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            label="Email"
                            name="email"
                            rules={[
                            {
                                required: true,
                                message: 'This field is required!',
                            },
                            {
                                pattern: new RegExp(/\S+@\S+\.\S+/),
                                message: 'Please enter a valid email'
                            }
                            ]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            wrapperCol={{
                            offset: 8,
                            span: 16,
                            }}
                        >
                            <Button type="primary" htmlType="submit">
                                Update
                            </Button>
                        </Form.Item>
                        </Form>
                    </TabPane>

                    
                    <TabPane tab="Update Address" key="2">
                        <h1 style={{textAlign: 'center'}}>Update Address</h1>
                        <Form
                        name="basic"
                        labelCol={{
                            span: 24,
                        }}
                        wrapperCol={{
                            span: 24,
                        }}
                        initialValues={{
                            remember: true,
                        }}
                        onFinish={onAddressFinish}
                        onFinishFailed={onFinishFailed}
                        autoComplete="off"
                        form={form}
                        >
                        <Form.Item
                            label="Street address"
                            name="street_address"
                            rules={[
                            {
                                required: true,
                                message: 'This field is required!',
                            }
                            ]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            label="City"
                            name="city"
                            rules={[
                            {
                                required: true,
                                message: 'This field is required!',
                            }
                            ]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            label="Post Code"
                            name="post_code"
                            rules={[
                            {
                                required: true,
                                message: 'This field is required!',
                            }
                            ]}
                            type="number"
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            wrapperCol={{
                            offset: 8,
                            span: 16,
                            }}
                        >
                            <Button type="primary" htmlType="submit">
                                Update
                            </Button>
                        </Form.Item>
                        </Form>
                    </TabPane>

                    <TabPane tab="Update Password" key="3">
                        <h1 style={{textAlign: 'center'}}>Update Password</h1>
                        <Form
                        name="basic"
                        labelCol={{
                            span: 24,
                        }}
                        wrapperCol={{
                            span: 24,
                        }}
                        initialValues={{
                            remember: true,
                        }}
                        onFinish={onPasswordFinish}
                        onFinishFailed={onFinishFailed}
                        autoComplete="off"
                        >
                        <Form.Item
                            label="New Password"
                            name="new_password"
                            rules={[
                            {
                                required: true,
                                message: 'This field is required!',
                            },
                            ]}
                        >
                            <Input.Password />
                        </Form.Item>

                        <Form.Item
                            label="Old Password"
                            name="old_password"
                            rules={[
                            {
                                required: true,
                                message: 'This field is required!',
                            },
                            ]}
                        >
                            <Input.Password />
                        </Form.Item>


                        <Form.Item
                            wrapperCol={{
                            offset: 8,
                            span: 16,
                            }}
                        >
                            <Button type="primary" htmlType="submit">
                                Update
                            </Button>
                        </Form.Item>
                        </Form>
                    </TabPane>
                    <TabPane tab="Change Image" key="4" style={{height: 'auto', display: 'flex', justifyContent: 'center', flexDirection: 'column'}}>
                        
                        <h1 style={{alignSelf: 'center'}}>Update Brand Image</h1>
                        <br />
                        <br />
                        <div  style={{alignSelf: 'center'}}>
                        <Form
                            name="basic"
                            labelCol={{
                                span: 24,
                            }}
                            wrapperCol={{
                                span: 24,
                            }}
                            initialValues={{
                                remember: true,
                            }}
                            onFinish={onUploadFinish}
                            onFinishFailed={onFinishFailed}
                            autoComplete="off"
                        >
                            
                            <Form.Item
                            label="Brand Image"
                            name="brand_image"
                            rules={[
                            {
                                required: true,
                                message: 'This field is required!',
                            },
                            ]}
                        >
                            <Upload 
                                multiple={false}
                                maxCount={1}
                                {...props}
                                listType="picture-card"
                                className="avatar-uploader"
                                beforeUpload={beforeUpload}
                                onChange={handleChange}
                                previewFile={false}
                                onRemove={(file)=>onRemove(file)}
                                
                            >
                                {imageUrl ? <img src={imageUrl} alt="avatar" style={{ width: '100%' }} /> : uploadButton}
                            </Upload>
                            </Form.Item>
                            

                            <Form.Item>
                                <Button type="primary" htmlType="submit">
                                    Update
                                </Button>
                            </Form.Item>
                        </Form>
                        </div>

                    </TabPane>
                </Tabs>
            
         </Container>
        </Wrapper>
     );
}
 
export default connect(null,{getProfileDetails,updateProfile,updateAddress,updatePassword,updateBrandImage})(Setting);